import vuetify from '@/main';
// Users
import UserTools from './user/UserTools.vue';
import UserInfo from './user/UserInfo.vue';
import UserBilling from './user/UserRates.vue';

// Teams
import SharedExpense from './shared/SharedExpense.vue';
import SharedCharges from './shared/SharedCharges.vue';
import UserTasks from './shared/UserTasks.vue';
import SharedMatterTags from './shared/SharedMatterTags.vue';

// Company
import CompanyInfo from './company/CompanyInfo.vue';
import RolesSettings from './company/RolesSettings.vue';
import LedesSettings from './company/LedesSettings.vue';
import TrustAccounting from './company/TrustAccounting/TrustAccounting.vue';
import FieldMapping from './company/FieldMapping/FieldMapping.vue';
import CompanyUsers from './company/CompanyUsers.vue';
import MaxioCompanySubscription from './subscription/MaxioSubbscription/MaxioCompanySubscription.vue';
import InvoiceHeaderPage from './company/InvoiceEmail/InvoiceHeaderPage.vue';
import ReportsSettings from './company/ReportSettings/ReportsSettings.vue';
import CompanyAutoIDs from './company/CompanyAutoIDs.vue';
import CompanyWorkflow from './company/CompanyWorkflow.vue';
import CompanyInvoice from './company/InvoicePreview/CompanyInvoice.vue';
import RateGroupMainPage from './company/RateGroup/RateGroupMainPage.vue';

// Integrations
import Api from './integrations/Api.vue';
import GravityIntegration from './integrations/GravityIntegration.vue';
import NetDocsIntegration from './integrations/NetDocsIntegration.vue';
import M365Integration from './integrations/M365Integration.vue';
import PayabliIntegration from './integrations/PayabliIntegration.vue';
import AgentAccess from './agentAccess/AgentAccess.vue';
import CompanyBilling from '../settings/integrations/QBO/CompanyBilling.vue';
import CustomFields from '../settings/integrations/QBO/CustomFields.vue';
import CreateChargeModal from '../fixedfees/components/CreateChargeModal.vue';
import CustomFieldsPage from './company/CustomFields/CustomFieldsPage.vue';

// firm
import FirmLists from './firms/FirmLists.vue';

// internal
import CompanyReset from './internal/CompanyReset.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider) {
  $stateProvider.state('settings', {
    track: 'Settings',
    url: '/settings',
    template: '<div class="flex w-full h-full"><div id="vue-settings-nav"></div><div ui-view class="scrollable flex-1"></div></div>',
    controller: 'SettingsCtrl',
    redirectTo: 'settings.user'
  })
  // company settings
  .state('settings.company', {
    url: '/company',
    redirectTo: 'settings.company.info',
    template: '<div ui-view></div>'
  }).state('settings.company.import', {
    url: '/import',
    template: require('./company/views/import.html'),
    controller: 'CompanyImportCtrl'
  }).state('settings.company.integrations', {
    url: '/integrations',
    ...vuetify(GravityIntegration)
  }).state('settings.company.netdocs', {
    url: '/netdocs',
    ...vuetify(NetDocsIntegration)
  }).state('settings.company.m365', {
    url: '/m365',
    ...vuetify(M365Integration)
  }).state('settings.company.payabli', {
    url: '/payabli',
    ...vuetify(PayabliIntegration)
  }).state('settings.company.agentAccess', {
    track: 'Settings:AgentAccess',
    url: '/agent-access',
    ...vuetify(AgentAccess)
  }).state('settings.company.info', {
    url: '/info',
    ...vuetify(CompanyInfo)
  }).state('settings.company.ledes', {
    url: '/ledes',
    ...vuetify(LedesSettings)
  }).state('settings.company.roles', {
    url: '/roles',
    ...vuetify(RolesSettings)
  }).state('settings.company.fieldMapping', {
    url: '/fieldMapping',
    ...vuetify(FieldMapping)
  }).state('settings.company.reports', {
    url: '/reports',
    ...vuetify(ReportsSettings)
  }).state('settings.company.customFields', {
    url: '/customFields',
    ...vuetify(CustomFields)
  }).state('settings.company.customFields2', {
    url: '/customFields2?panel&customFieldId',
    ...vuetify(CustomFieldsPage)
  }).state('settings.company.invoiceEmail', {
    url: '/invoiceEmail',
    ...vuetify(InvoiceHeaderPage)
  }).state('settings.company.maxioCompanySubscription', {
    url: '/maxio-subscription',
    ...vuetify(MaxioCompanySubscription)
  }).state('settings.company.workflow', {
    track: 'Settings:Workflow',
    url: '/workflow',
    ...vuetify(CompanyWorkflow)
  }).state('settings.company.invoice', {
    track: 'Settings:Invoice',
    url: '/invoice',
    ...vuetify(CompanyInvoice)
  }).state('settings.company.users', {
    track: 'Settings:Users',
    url: '/users?panel&userId&tab',
    ...vuetify(CompanyUsers)
  }).state('settings.company.rateGroups', {
    track: 'Settings:rateGroups',
    url: '/rateGroups',
    ...vuetify(RateGroupMainPage)
  }).state('settings.company.trust', {
    url: '/trust',
    ...vuetify(TrustAccounting)
  }).state('settings.company.api', {
    url: '/api',
    ...vuetify(Api)
  }).state('settings.company.billing', {
    track: 'Settings:Billing',
    url: '/billing',
    ...vuetify(CompanyBilling)
  }).state('settings.company.billing.import', {
    url: '/import',
    views: {
      '@': {
        template: require('../accounting/views/import.html'),
        controller: 'QuickbooksImportCtrl'
      }
    }
  }).state('settings.company.autoIDs', {
    url: '/autoIDs',
    ...vuetify(CompanyAutoIDs)
  }).state('settings.company.reset', {
    url: '/reset/{state}',
    ...vuetify(CompanyReset)
  }).state('settings.shared', {
    url: '/shared',
    redirectTo: 'settings.shared.tasks',
    template: '<div ui-view></div>'
  }).state('settings.shared.tasks', {
    url: '/tasks',
    ...vuetify(UserTasks)
  }).state('settings.shared.charges', {
    url: '/charges',
    ...vuetify(SharedCharges)
  }).state('settings.shared.charges.edit', {
    url: '/edit/{chargeId}',
    views: {
      edit: {
        ...vuetify(CreateChargeModal)
      }
    },
    params: {
      chargeId: null,
      groupId: null,
      ledes: false,
      fixedFeeTemplate: true,
      entryPoint: 'fixed_fee_template_settings'
    }
  }).state('settings.shared.expenses', {
    url: '/expenses',
    ...vuetify(SharedExpense)
  }).state('settings.shared.tags', {
    url: '/tags',
    ...vuetify(SharedMatterTags)
  }).state('settings.user', {
    url: '/user',
    redirectTo: 'settings.user.info',
    template: '<div ui-view></div>'
  }).state('settings.user.info', {
    url: '/info',
    ...vuetify(UserInfo)
  }).state('settings.user.tools', {
    track: 'Settings:Tools',
    url: '/tools',
    ...vuetify(UserTools)
  }).state('settings.user.billing', {
    url: '/billing',
    ...vuetify(UserBilling)
  }).state('settings.firms', {
    url: '/firms',
    template: '<div ui-view></div>'
  }).state('settings.firms.list', {
    url: '/list',
    ...vuetify(FirmLists)
  });
}]);